import React from 'react';
import { ActiveTab } from '../../types';

export interface TabNavItem {
  key: ActiveTab;
  label: string;
  icon: React.ReactNode;
}

interface TabNavProps {
  items: TabNavItem[];
  activeTab: ActiveTab;
  onChange: (tab: ActiveTab) => void;
  align?: 'left' | 'right';
}

export const TabNav: React.FC<TabNavProps> = ({ items, activeTab, onChange, align = 'left' }) => {
  if (items.length === 0) return null;

  return (
    <div className={`flex flex-wrap gap-1.5 ${align === 'right' ? 'ml-auto' : ''}`}>
      {items.map(({ key, label, icon }) => {
        const isActive = activeTab === key;
        return (
          <button
            key={key}
            onClick={() => onChange(key)}
            className={`inline-flex items-center gap-1.5 px-3 py-2 rounded-md text-sm font-medium transition-colors focus:outline-none
              ${
                isActive
                  ? 'bg-brand-50 text-brand-800 border border-brand-200'
                  : 'text-slate-600 border border-transparent hover:bg-slate-100 hover:text-slate-800'
              }`}
          >
            {icon}
            {label}
          </button>
        );
      })}
    </div>
  );
};

export default TabNav;
